import {
  type CustomLayerRecoverAction,
  CustomLayerTargetType,
  type CustomLayerOriginType,
  type CustomLayerStatus,
  type ICustomLayer,
  type IRecoverableCustomLayer,
} from "./custom-layers.interface";

import type { SchoolTypeEnum } from "../reports/reports.interface";

export interface CustomLayerApiWire {
  id: string;
  name: string;
  districtId: string;
  status: string;
  jobId: string | null;
  scheduledMergeDate: string | null;
  archivedAt: string | null;
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
  createdById: string | null;
  creator?: { id: string; fullName: string } | null;
  schoolType: string | null;
  layerType: string;
  targetType?: string | null;
}

export interface RecoverableCustomLayerApiWire extends CustomLayerApiWire {
  archivedBy?: { id: string; fullName: string } | null;
  recoverAction: string;
}

export function adaptCustomLayerFromApi(dto: CustomLayerApiWire): ICustomLayer {
  const { schoolType, targetType, creator, ...rest } = dto;

  return {
    ...rest,
    status: rest.status as CustomLayerStatus,
    layerType: rest.layerType as CustomLayerOriginType,
    creator: creator ?? null,
    type: (schoolType as SchoolTypeEnum | null) ?? null,
    targetType: (targetType as CustomLayerTargetType | null | undefined)
      ?? CustomLayerTargetType.SCHOOL_BOUNDARY,
  };
}

export function adaptRecoverableCustomLayerFromApi(
  dto: RecoverableCustomLayerApiWire,
): IRecoverableCustomLayer {
  const { archivedBy, recoverAction, ...layerWire } = dto;
  const layer = adaptCustomLayerFromApi(layerWire);

  return {
    ...layer,
    archivedBy: archivedBy ?? null,
    recoverAction: recoverAction as CustomLayerRecoverAction,
  };
}
